"use client";

export const en = {
  // Header
  "nav.services": "Services",
  "nav.about": "About",
  "nav.team": "Team",
  "nav.gallery": "Gallery",
  "nav.reviews": "Reviews",
  "nav.contacts": "Contacts",
  "nav.login": "Login",
  "nav.dashboard": "Dashboard",

  // Hero
  "hero.badge": "Care for your pets",
  "hero.title": "Full-cycle veterinary clinic",
  "hero.subtitle": "Modern equipment, experienced doctors and individual approach to each patient",
  "hero.appointment": "Book appointment",
  "hero.services": "Our services",
  "hero.stats.experience": "Years of experience",
  "hero.stats.clients": "Happy clients",
  "hero.stats.support": "24/7 support",

  // Services
  "services.title": "Our services",
  "services.subtitle": "Full range of veterinary services for your pet",
  "services.consultation": "Consultations",
  "services.consultation.desc": "Professional consultations by experienced veterinarians",
  "services.surgery": "Surgery",
  "services.surgery.desc": "Planned and emergency operations of any complexity",
  "services.diagnostics": "Diagnostics",
  "services.diagnostics.desc": "Modern equipment for accurate diagnostics",
  "services.vaccination": "Vaccination",
  "services.vaccination.desc": "Full range of vaccinations and prevention",
  "services.hospitalization": "Hospitalization",
  "services.hospitalization.desc": "24/7 care and monitoring",
  "services.grooming": "Grooming",
  "services.grooming.desc": "Professional care and hygiene",

  // About
  "about.title": "About our clinic",
  "about.subtitle": "We have been working since 2008 and have helped thousands of animals",
  "about.mission": "Our mission",
  "about.mission.text": "To provide quality veterinary care using modern technologies and an individual approach to each patient.",
  "about.values": "Our values",
  "about.values.text": "Professionalism, care, honesty and love for animals are the foundation of our work.",
  "about.equipment": "Equipment",
  "about.equipment.text": "Modern diagnostic and surgical equipment of European quality.",

  // Team
  "team.title": "Our team",
  "team.subtitle": "Experienced specialists with love for animals",
  "team.experience": "years of experience",
  "team.position.head": "Chief Veterinarian",
  "team.position.surgeon": "Surgeon",
  "team.position.therapist": "Therapist",
  "team.position.nurse": "Senior Nurse",

  // Gallery
  "gallery.title": "Our clinic",
  "gallery.subtitle": "Modern equipment and comfortable atmosphere",
  "gallery.reception": "Reception",
  "gallery.surgery": "Operating room",
  "gallery.ward": "Ward",
  "gallery.diagnostics": "Diagnostic room",

  // Reviews
  "reviews.title": "Our clients' reviews",
  "reviews.subtitle": "What pet owners say about us",

  // FAQ
  "faq.title": "Frequently asked questions",
  "faq.subtitle": "Answers to popular questions",
  "faq.q1": "How to book an appointment?",
  "faq.a1": "You can book through our website, by phone, or via Telegram bot.",
  "faq.q2": "Do you work 24/7?",
  "faq.a2": "Yes, our clinic works 24/7. Emergency care is available at any time.",
  "faq.q3": "What payment methods do you accept?",
  "faq.a3": "We accept cash, cards, and electronic payments.",
  "faq.q4": "Do I need a prior appointment?",
  "faq.a4": "We recommend booking in advance for scheduled appointments. Emergency cases are accepted without appointment.",

  // Footer
  "footer.about": "About clinic",
  "footer.about.text": "Veterinary clinic with modern equipment and experienced specialists. We work for the health of your pets.",
  "footer.links": "Quick links",
  "footer.contacts": "Contacts",
  "footer.rights": "All rights reserved",

  // Auth
  "auth.title": "ELVET",
  "auth.subtitle": "Management System Login",
  "auth.login": "Login",
  "auth.phoneLogin": "Phone Login",
  "auth.registration": "Registration",
  "auth.loginByMethod": "Choose your login method",
  "auth.phone": "Phone",
  "auth.phonePlaceholder": "+998 90 123 45 67",
  "auth.phoneHelper": "Format: +998 XX XXX XX XX",
  "auth.invalidPhone": "Invalid phone format",
  "auth.phoneNotFound": "Phone not found in system",
  "auth.password": "Password",
  "auth.passwordPlaceholder": "••••••••",
  "auth.forgotPassword": "Forgot password?",
  "auth.loginButton": "Login",
  "auth.registerViaTelegram": "Register via Telegram",
  "auth.telegramRegisterDesc": "Quick and secure registration via Telegram bot",
  "auth.telegramNote": "After registration in the bot, you will be automatically authorized on the website",
  "auth.error": "Error",
  "auth.loginError": "Login Error",
  "auth.loginSuccess": "Login Successful",
  "auth.welcome": "Welcome!",
  "auth.passwordChangeRequired": "Password Change Required",
  "auth.setPermPassword": "Please set a permanent password",
  "auth.visitClinic": "Visit Our\nVeterinary Clinic",
  "auth.professionalCare": "Professional Care\nfor Your Pets",
  "auth.contactTelegram": "Contact via Telegram",
  "auth.backToHome": "Back to Home",

  // Contact
  "contact.title": "Contacts",
  "contact.subtitle": "Get in touch with us",
  "contact.address": "Address",
  "contact.phone": "Phone",
  "contact.email": "Email",
  "contact.schedule": "Working Hours",
  "contact.schedule.text": "24/7, No days off",
  
  // Contact Form
  "contacts.form.title": "Write to Us",
  "contacts.form.subtitle": "Leave your contacts and we will get in touch",
  "contacts.form.phone": "Phone",
  "contacts.form.phoneHelper": "Format: +998-XX-XXX-XX-XX",
  "contacts.form.phoneInvalid": "Please enter a valid phone number in format +998-XX-XXX-XX-XX",
  "contacts.form.fullName": "Full Name",
  "contacts.form.fullNamePlaceholder": "John Doe",
  "contacts.form.firstName": "First name",
  "contacts.form.firstNamePlaceholder": "John",
  "contacts.form.lastName": "Last name",
  "contacts.form.lastNamePlaceholder": "Doe",
  "contacts.form.message": "Message (optional)",
  "contacts.form.messagePlaceholder": "Write your message or question...",
  "contacts.form.messageHelper": "Minimum 5 characters, maximum 2000",
  "contacts.form.submit": "Submit",
  "contacts.form.sending": "Sending...",
  "contacts.form.success": "Thank you!",
  "contacts.form.successDesc": "We will contact you soon",
  "contacts.form.error": "Error",
  "contacts.form.invalidPhone": "Invalid phone format. Use format +998XXXXXXXXX",
  "contacts.form.invalidName": "Name must contain only letters, spaces and hyphens (2-64 characters)",

  // Dashboard
  "dashboard.welcome": "Welcome",
  "dashboard.client": "Client Dashboard",
  "dashboard.moderator": "Moderator Panel",
  "dashboard.doctor": "Doctor Panel",
  "dashboard.admin": "Admin Panel",
  "dashboard.nurse": "Nurse Panel",
  "dashboard.logout": "Logout",
  "dashboard.myPets": "My Pets",
  "dashboard.medicalHistory": "Medical Cards History",
  "dashboard.medicalHistoryShort": "History",
  "dashboard.medicalCards": "Medical Cards",
  "dashboard.appointments": "Appointments",
  "dashboard.profile": "Profile",

  // Doctor page
  "doctor.newCard.title": "New medical card",
  "doctor.newCard.subtitle": "Fill pet info, diagnosis, analyses, services and medicines",
  "doctor.sections.petAndExam": "Pet and examination",
  // Tabs (Doctor) - kept for backward compatibility
  "doctor.tabs.clients": "Clients",
  "doctor.tabs.services": "Services",
  "doctor.tabs.medicines": "Medicines",
  "doctor.tabs.history": "History",
  "doctor.tabs.rooms": "Rooms",
  // Doctor sidebar navigation
  "doctor.sidebar.navigation": "Navigation",
  "doctor.sidebar.main": "Main",
  "doctor.sidebar.clients": "Clients",
  "doctor.sidebar.services": "Services",
  "doctor.sidebar.medicines": "Medicines",
  "doctor.sidebar.history": "History",
  "doctor.sidebar.rooms": "Rooms",
  "doctor.sidebar.salary": "Salary History",
  "doctor.sidebar.collapse": "Collapse sidebar",
  "doctor.sidebar.expand": "Expand sidebar",
  "doctor.sidebar.hint": "Use sidebar to navigate between sections",
  "doctor.pet.selectLabel": "Client's pet",
  "doctor.pet.selectPlaceholder": "Select a pet",
  "doctor.pet.loading": "Loading pets…",
  "doctor.pet.loadError": "Failed to load pets",
  "doctor.pet.none": "No pets",
  "doctor.pet.create": "Create pet",
  "doctor.pet.createHelp": "Create a pet card for the client",
  "doctor.pet.addNew": "Add new pet",
  "doctor.pet.form.title": "New pet",
  "doctor.pet.form.subtitle": "Create a pet for the client",
  "doctor.pet.name": "Name",
  "doctor.pet.namePlaceholder": "Barsik",
  "doctor.pet.species": "Species",
  "doctor.pet.speciesPlaceholder": "Select species",
  "doctor.pet.species.dog": "Dog",
  "doctor.pet.species.cat": "Cat",
  "doctor.pet.species.bird": "Bird",
  "doctor.pet.species.reptile": "Reptile",
  "doctor.pet.species.other": "Other",
  "doctor.pet.gender": "Gender",
  "doctor.pet.genderPlaceholder": "Select gender",
  "doctor.pet.gender.male": "Male",
  "doctor.pet.gender.female": "Female",
  "doctor.pet.breed": "Breed",
  "doctor.pet.breedPlaceholder": "British",
  "doctor.pet.birthDate": "Birth date",
  "doctor.pet.color": "Color",
  "doctor.pet.colorPlaceholder": "Ginger",
  "doctor.pet.weight": "Weight (kg)",
  "doctor.pet.weightPlaceholder": "4.5",
  "doctor.pet.description": "Description",
  "doctor.pet.descriptionPlaceholder": "No chronic diseases...",

  "doctor.vitals.weight": "Weight",
  "doctor.vitals.weightPlaceholder": "4.2",
  "doctor.vitals.temperature": "Temperature",
  "doctor.vitals.temperaturePlaceholder": "38.5",
  "doctor.vitals.bloodPressure": "Blood pressure (mmHg)",
  "doctor.vitals.bloodPressurePlaceholder": "120",
  "doctor.vitals.heartRate": "Heart rate (bpm)",
  "doctor.vitals.heartRatePlaceholder": "90",
  "doctor.vitals.respiratoryRate": "Respiratory rate (rpm)",
  "doctor.vitals.respiratoryRatePlaceholder": "20",
  "doctor.vitals.mucous": "Mucous membranes",
  "doctor.vitals.mucousPlaceholder": "pink, moist",
  "doctor.vitals.chest": "Chest condition",
  "doctor.vitals.chestPlaceholder": "no wheezing, percussion clear",
  "doctor.vitals.anamnez": "Anamnesis (complaints & symptoms)",
  "doctor.vitals.anamnezPlaceholder": "Current complaints, history of illness, symptoms...",
  "doctor.vitals.naznacheniya": "Prescriptions (Naznacheniya)",
  "doctor.vitals.naznacheniyaPlaceholder": "Treatment plan, medications, care instructions...",
  "doctor.vitals.statusSection": "Patient Status (Vitals)",
  "doctor.vitals.generalCondition": "Patient status",
  "doctor.vitals.generalConditionPlaceholder": "Weight: 4.2 kg, Temperature: 38.5°C, Blood pressure: 120/80, Heart rate: 90 bpm, Respiratory rate: 20 rpm, Mucous membranes: pink moist...",
  "doctor.revisitDate": "Revisit date",
  "client.medicalCards.naznacheniya": "Prescription",
  "client.medicalCards.naznacheniya.empty": "—",

  "doctor.services.title": "Services",
  "doctor.services.subtitle": "Select services and specify quantity and description",
  "doctor.medicines.title": "Medicines",
  "doctor.medicines.subtitle": "Select medicines and specify quantity and dosage",
  "doctor.feeds.title": "Feeds",
  "doctor.feeds.subtitle": "Select feeds and specify quantity",
  "doctor.search.servicePlaceholder": "Search service...",
  "doctor.search.medicinePlaceholder": "Search medicine...",
  "doctor.search.feedPlaceholder": "Search feed...",
  "doctor.price": "{{price}} sum",
  "doctor.inStock": "In stock: {{stock}}",
  "doctor.qtyPlaceholder": "Qty",
  "doctor.qtyZeroPlaceholder": "0",
  "doctor.serviceDescPlaceholder": "Description of performed service",
  "doctor.dosagePlaceholder": "Dosage",
  "doctor.clear": "Clear",

  "doctor.stationary.title": "Hospitalization",
  "doctor.stationary.subtitle": "Arrange hospitalization if needed",
  "doctor.stationary.checkbox": "Hospitalize",
  "doctor.stationary.period": "Stay period",
  "doctor.stationary.selectPeriod": "Select a period",
  "doctor.stationary.noPeriods": "No stationary periods are configured. Ask an administrator to add one.",
  "doctor.stationary.loadError": "Failed to load stationary periods",
  "doctor.stationary.room": "Room",
  "doctor.stationary.selectRoom": "Select room",
  "doctor.stationary.roomSelected": "Selected: {{room}}",
  "doctor.stationary.roomIdNote": "Room ID will be sent: {{id}}",
  "doctor.stationary.startDate": "Admission date",
  "doctor.stationary.endDate": "Discharge date",

  "doctor.freeRooms.title": "Available rooms",
  "doctor.freeRooms.subtitle": "Select a room for the patient",
  "doctor.freeRooms.loading": "Loading available rooms…",
  "doctor.freeRooms.id": "ID: {{id}}",
  "doctor.freeRooms.pricePerDay": "Price/day: {{price}}",
  "doctor.freeRooms.select": "Select",
  "doctor.freeRooms.empty": "No free rooms found",

  "doctor.schedule.title": "Stationary schedule",
  "doctor.schedule.subtitle": "Specify the period and add tasks for the nurse",
  "doctor.schedule.datetime": "Date and time",
  "doctor.schedule.hint": "Specify when the patient should return or start hospitalization.",
  "doctor.schedule.loading": "Loading schedule data…",
  "doctor.schedule.save": "Save schedule",
  "doctor.schedule.cardMissing": "Medical card not selected",
  "doctor.schedule.datetimeRequired": "Specify schedule date and time",
  "doctor.schedule.invalidDate": "Invalid date or time",
  "doctor.schedule.createError": "Failed to create schedule",
  "doctor.schedule.saveSuccess": "Schedule saved",
  "doctor.schedule.saveErrorTitle": "Failed to save schedule",
  "doctor.schedule.saveErrorDescription": "An error occurred while saving the schedule",
  "doctor.schedule.nursesLoadError": "Failed to load nurses",
  "doctor.schedule.servicesLoadError": "Failed to load services",

  // Doctor card creation flow
  "doctor.create.validation.selectClient": "Select a client",
  "doctor.create.validation.selectPet": "Select a pet",
  "doctor.create.validation.selectNurse": "Select an assigned nurse",
  "doctor.create.validation.diagnosis": "Enter diagnosis",
  "doctor.create.validation.requiredFieldsTitle": "Missing required fields",
  "doctor.create.validation.selectItems": "Add at least one service, medicine or feed",
  "doctor.create.validation.medicineDosage": "Specify dosage for each selected medicine",
  "doctor.create.determineDoctorError": "Doctor profile not found",
  "doctor.create.tryLater": "Try again later or contact administrator",
  "doctor.create.createErrorTitle": "Failed to create medical card",
  "doctor.create.serverError": "Server error",
  "doctor.create.idMissingTitle": "Medical card ID missing",
  "doctor.create.idMissingDescription": "Server did not return card ID",
  "doctor.create.successTitle": "Medical card created",
  "doctor.create.successDescription": "Card #{{id}} saved successfully",
  "doctor.create.nursesLoadError": "Failed to load nurses",
  "doctor.create.assignedNurseLabel": "Assigned Nurse",
  "doctor.create.assignedNursePlaceholder": "Select nurse to assign",
  "doctor.create.noNurses": "No nurses available",
  "doctor.create.pet.noClient": "Select a client before creating a pet",
  "doctor.create.pet.nameRequired": "Enter pet name",
  "doctor.create.pet.speciesRequired": "Select pet species",
  "doctor.create.pet.genderRequired": "Select pet gender",
  "doctor.create.pet.successTitle": "Pet created",
  "doctor.create.pet.successDescription": "{{name}} added to client",
  "doctor.create.pet.errorTitle": "Failed to create pet",
  "doctor.create.pet.errorUnknown": "Unknown error while creating pet",

  "doctor.edit.title": "Edit medical card",
  "doctor.edit.subtitle": "Editing is available only before payment. Changes are saved partially.",
  "doctor.edit.stationarySubtitle": "Choose the stationary stay period configured by the administrator",
  "doctor.edit.stationaryRequiredTitle": "Stationary period required",
  "doctor.edit.stationaryRequiredDescription": "Select a stationary stay period before saving.",

  // Doctor salary history
  "doctor.salary.today": "Today's income",
  "doctor.salary.weekly": "Weekly income",
  "doctor.salary.monthly": "Monthly income",
  "doctor.salary.dropdown.weekly": "Weekly",
  "doctor.salary.dropdown.monthly": "Monthly",
  "doctor.salary.total": "Total",
  "doctor.salary.events": "Events",
  "doctor.salary.empty": "No salary events",
  "doctor.salary.loading": "Loading salary history…",
  "doctor.salary.error": "Failed to load",
  "doctor.salary.errorDesc": "Could not fetch salary history",
  "doctor.salary.source.SERVICE_USAGE": "Service usage",
  "doctor.salary.source.OTHER": "Other",
  
  // Doctor schedule task builder (add/edit tasks for hospitalization schedule)
  "doctor.schedule.addTaskTitle": "Add task",
  "doctor.schedule.addTaskSubtitle": "Who, when and what to do",
  "doctor.schedule.task.validationTitle": "Check task details",
  "doctor.schedule.task.validationDescription": "Fill name, description, timings, nurse and service",
  "doctor.schedule.task.validationExtended": "Task requires name, description, start/end time, nurse and service",
  "doctor.schedule.task.nameLabel": "Task name",
  "doctor.schedule.task.namePlaceholder": "Injection, feeding...",
  "doctor.schedule.task.startDateLabel": "Start date",
  "doctor.schedule.task.startTimeLabel": "Start time",
  "doctor.schedule.task.deadlineDateLabel": "Deadline date",
  "doctor.schedule.task.deadlineTimeLabel": "Deadline time",
  "doctor.schedule.task.nurseLabel": "Nurse",
  "doctor.schedule.task.nurseSelectPlaceholder": "Select nurse",
  "doctor.schedule.task.nurseSelectLoading": "Loading…",
  "doctor.schedule.task.noUsers": "No available users",
  "doctor.schedule.task.serviceLabel": "Service",
  "doctor.schedule.task.serviceSelectPlaceholder": "Select service",
  "doctor.schedule.task.serviceSelectLoading": "Loading…",
  "doctor.schedule.task.noServices": "No services",
  "doctor.schedule.task.descriptionLabel": "Description",
  "doctor.schedule.task.descriptionPlaceholder": "Antibiotic injection, care...",
  "doctor.schedule.task.addButton": "Add",
  "doctor.schedule.task.createError": "Failed to create task",
  "doctor.schedule.tasksTitle": "Tasks",
  "doctor.schedule.tasksSubtitle": "Plan for the period",
  "doctor.schedule.tasksEmpty": "No tasks",
  "doctor.schedule.task.untitled": "Untitled",
  "doctor.schedule.task.persistedBadge": "saved",
  "doctor.schedule.task.startPrefix": "Start:",
  "doctor.schedule.task.deadlinePrefix": "Deadline:",
  "doctor.schedule.task.deleteButton": "Delete",

  // Generic fetch helper
  "doctor.fetch.errorTitle": "Failed to load data",
  "doctor.fetch.errorDescription": "Could not load {{resource}}",

  // Common additions
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.create": "Create",
  "common.creating": "Creating…",
  "common.saving": "Saving…",
  "common.loading": "Loading…",
  "common.empty": "No data",
  "common.view": "View",
  "common.close": "Close",
  "common.confirmPayment": "Confirm payment",
  "common.confirmed": "Confirmed",
  "common.error": "Error",
  "common.nothingFound": "Nothing found",
  
  // Tabs (Nurse)
  "nurse.tabs.procedures": "Procedures",
  "nurse.tabs.medicines": "Medicines",
  "nurse.tabs.schedule": "Schedule",

  // Tabs (Moderator)
  "moderator.tabs.billing": "Medical Cards",
  "moderator.tabs.visits": "Visits",
  "moderator.tabs.password": "Client password",
  "moderator.tabs.requests": "Requests",
  
  // Moderator dashboard KPI
  "moderator.kpi.medicinesAvailable": "Available medicines",
  "moderator.kpi.servicesCount": "Services total",
  "moderator.kpi.visitsCount": "Visits total",

  // Moderator medical cards section
  "moderator.medicalCards.title": "Medical cards",
  "moderator.medicalCards.subtitle": "Cards awaiting payment",
  "moderator.medicalCards.refresh": "Refresh list",

  // Moderator visits section
  "moderator.visits.create.title": "Create visit",
  "moderator.visits.create.subtitle": "Select client, doctor and pet",
  "moderator.visits.history.title": "Visit history",
  "moderator.visits.history.subtitle": "List of visits",
  "moderator.visits.refresh": "Refresh",

  // Moderator requests section
  "moderator.requests.title": "Client requests",
  "moderator.requests.subtitle": "Website contact submissions",
  "moderator.requests.refresh": "Refresh",

  // Moderator card modal
  "moderator.card.modal.title": "Card #{{id}}",
  "moderator.card.modal.subtitle": "View card and confirm payment",
  "moderator.card.modal.client": "Client",
  "moderator.card.modal.pet": "Pet",
  "moderator.card.modal.status": "Status",
  "moderator.card.modal.total": "Total",
  
  // Doctor clients tab & client profile
  "doctor.clients.title": "Clients",
  "doctor.clients.subtitle": "Client list and phone numbers",
  "doctor.profile.notFoundTitle": "Doctor profile not found",
  "doctor.profile.notFoundDescription": "Contact the administrator",
  "doctor.clients.searchPlaceholder": "Search client by name or phone...",
  "doctor.clients.loading": "Loading clients…",
  "doctor.clients.profileButton": "Profile",
  "doctor.clients.nothing": "Nothing found",
  "doctor.clients.total": "Total: {{count}}",
  "doctor.clientProfile.title": "Client profile",
  "doctor.clientProfile.subtitle": "Client card and medical cards",
  "doctor.clientProfile.phone": "Phone:",
  "doctor.clientProfile.address": "Address:",
  "doctor.clientProfile.description": "Description:",
  "doctor.clientProfile.close": "Close",
  "doctor.clientProfile.createCard": "Create medical card",
  "doctor.clientCards.title": "Client medical cards",
  "doctor.clientCards.subtitle": "Latest entries",
  "doctor.clientCards.loadError": "Failed to load medical cards",
  "doctor.clientCards.status.open": "Open",
  "doctor.clientCards.status.waiting": "Awaiting payment",
  "doctor.clientCards.status.closed": "Closed",
  "doctor.clientCards.edit": "Edit",
  "doctor.clientCards.empty": "No cards",

  // Doctor services list tab
  "doctor.servicesList.title": "Available services",
  "doctor.servicesList.subtitle": "Services catalog",
  "doctor.servicesList.searchPlaceholder": "Search service...",
  "doctor.servicesList.loading": "Loading services…",
  "doctor.servicesList.empty": "Nothing found",
  "doctor.servicesList.total": "Total: {{count}}",

  // Doctor medicines list tab
  "doctor.medicinesList.title": "Available medicines",
  "doctor.medicinesList.subtitle": "Stock inventory",
  "doctor.medicinesList.searchPlaceholder": "Search medicine...",
  "doctor.medicinesList.loading": "Loading medicines…",
  "doctor.medicinesList.empty": "Nothing found",
  "doctor.medicinesList.stockPrefix": "Stock: {{stock}}",
  "doctor.medicinesList.unitDefault": "pcs",
  "doctor.medicinesList.total": "Total: {{count}}",

  // Doctor history tab
  "doctor.history.title": "Card history (mine)",
  "doctor.history.subtitle": "Recently created/opened cards",
  "doctor.history.loading": "Loading history…",
  "doctor.history.status.open": "Open",
  "doctor.history.status.waiting": "Awaiting payment",
  "doctor.history.status.closed": "Closed",
  "doctor.history.edit": "Edit",
  "doctor.history.viewDisabled": "View unavailable",
  "doctor.history.empty": "No data",
  "doctor.history.total": "Total: {{count}}",

  // Doctor rooms tab
  "doctor.rooms.title": "Rooms",
  "doctor.rooms.subtitle": "Available stationary rooms",
  "doctor.rooms.loading": "Loading rooms…",
  "doctor.rooms.roomLabel": "Room",
  "doctor.rooms.free": "Free",
  "doctor.rooms.busy": "Occupied",
  "doctor.rooms.pricePerDayPrefix": "Price/day:",
  "doctor.rooms.noDescription": "No description",
  "doctor.rooms.empty": "No data",
  "doctor.rooms.total": "Total: {{count}}",

  // Fallback labels
  "doctor.pet.fallback": "Pet #{{id}}",
  "doctor.room.fallback": "Room #{{id}}",

  // Pagination/common nav
  "common.prev": "Prev",
  "common.next": "Next",
  "doctor.currency.som": "UZS",
  
  // Doctor hero & banner
  "doctor.hero.subtitle": "Doctor dashboard",
  "doctor.hero.fallbackRole": "Doctor",
  "doctor.banner.edit": "Change",
  "doctor.banner.loading": "Uploading…",
  
  // Doctor stats boxes
  "doctor.stats.services.title": "Services",
  "doctor.stats.services.subtitle": "Available (types)",
  "doctor.stats.medicines.title": "Medicines",
  "doctor.stats.medicines.subtitle": "In stock (types)",
  "doctor.stats.feeds.title": "Feeds",
  "doctor.stats.feeds.subtitle": "Available (types)",
  
  // Common navigation
  "common.goHome": "Go home",
  "common.delete": "Delete",
  "common.search": "Search",

  // Edit card modal - services
  "doctor.edit.services.title": "Services in invoice",
  "doctor.edit.services.subtitle": "Change quantity, description or add new services",
  "doctor.edit.services.fallback": "Service #{{id}}",
  "doctor.edit.services.descriptionPlaceholder": "Description",
  "doctor.edit.services.delete": "Delete",
  "doctor.edit.services.empty": "No services",
  "doctor.edit.services.add": "Add service",
  "doctor.edit.services.search": "Search",

  // Edit card modal - medicines
  "doctor.edit.medicines.title": "Medicines in invoice",
  "doctor.edit.medicines.subtitle": "Change quantity/dosage or add new medicines",
  "doctor.edit.medicines.fallback": "Medicine #{{id}}",
  "doctor.edit.medicines.dosagePlaceholder": "Dosage",
  "doctor.edit.medicines.delete": "Delete",
  "doctor.edit.medicines.empty": "No medicines",
  "doctor.edit.medicines.add": "Add medicine",
  "doctor.edit.medicines.search": "Search",

  // Edit card modal - feeds
  "doctor.edit.feeds.title": "Feeds in invoice",
  "doctor.edit.feeds.subtitle": "Change quantity or add new feeds",
  "doctor.edit.feeds.fallback": "Feed #{{id}}",
  "doctor.edit.feeds.selectPlaceholder": "Select feed",
  "doctor.edit.feeds.delete": "Delete",
  "doctor.edit.feeds.empty": "No feeds",
  "doctor.edit.feeds.add": "Add feed",
  "doctor.edit.feeds.search": "Search",
  
  // Client dashboard - Appointments
  "client.appointments.title": "My appointments",
  "client.appointments.create": "Book an appointment",
  "client.appointments.status.waiting": "Waiting",
  "client.appointments.status.confirmed": "Confirmed",
  "client.appointments.status.canceled": "Canceled",
  "client.appointments.cancel.confirmTitle": "Cancel appointment?",
  "client.appointments.cancel.confirmDescription": "Are you sure you want to cancel this appointment?",
  "client.appointments.toast.createSuccess": "Appointment created",
  "client.appointments.toast.createError": "Failed to create appointment",
  "client.appointments.toast.cancelSuccess": "Appointment canceled",
  "client.appointments.toast.cancelError": "Failed to cancel appointment",
  "client.appointments.dialogTitle": "Book appointment",
  "client.appointments.dialogDescription": "Select date, time and doctor",
  "client.appointments.pet.label": "Pet",
  "client.appointments.pet.placeholder": "Select pet",
  "client.appointments.doctor.label": "Doctor",
  "client.appointments.doctor.placeholder": "Select doctor",
  "client.appointments.date.label": "Date *",
  "client.appointments.time.label": "Time *",
  "client.appointments.service.label": "Service type",
  "client.appointments.service.placeholder": "Consultation, vaccination...",
  "client.appointments.notes.label": "Notes",
  "client.appointments.notes.placeholder": "Describe the problem...",
  "client.appointments.submit": "Book",
  "client.appointments.submitting": "Booking...",
  "client.appointments.manageDescription": "Manage your appointments",
  "client.appointments.empty": "You have no upcoming appointments",
  "client.appointments.petPrefix": "Pet:",
  "client.appointments.doctorPrefix": "Doctor:",
  "client.appointments.status.completed": "Completed",
  "client.appointments.status.cancelled": "Canceled",

  // Client dashboard - Password dialog
  "client.password.dialogTitle": "Set a permanent password",
  "client.password.passwordMismatch": "Passwords do not match",
  "client.password.passwordTooShort": "Password must be at least 6 characters",
  "client.password.saveSuccess": "Password saved",
  "client.password.saveError": "Failed to save password",

  // Client dashboard - Medical cards viewer
  "client.medicalCards.title": "Medical cards",
  "client.medicalCards.historyTitle": "Visit history",
  "client.medicalCards.status.pending": "Pending",
  "client.medicalCards.status.paid": "Paid",
  "client.medicalCards.status.partlyPaid": "Partly Paid",
  "client.medicalCards.stationaryBadge": "Stationary",
  "client.medicalCards.services": "Services",
  "client.medicalCards.medicines": "Medicines",
  "client.medicalCards.services.empty": "No services",
  "client.medicalCards.medicines.empty": "No medicines",
  "client.medicalCards.stationaryRoom.title": "Stationary room",
  "client.medicalCards.stationaryRoom.payment": "Stationary room payment",

  // Client dashboard - Pets manager
  "client.pets.title": "My pets",
  "client.pets.addPet": "Add pet",
  "client.pets.updatePet": "Update pet",
  "client.pets.empty": "No registered pets",
  "client.pets.namePlaceholder": "Barsik",
  "client.pets.breedPlaceholder": "Labrador",
  "client.pets.toast.createSuccess": "Pet added",
  "client.pets.toast.updateSuccess": "Pet updated",
  "client.pets.toast.deleteSuccess": "Pet deleted",
  "client.pets.toast.errorGeneric": "Operation failed",

  // Client dashboard - Profile editor
  "client.profile.title": "My profile",
  "client.profile.subtitle": "Personal information",
  "client.profile.firstName": "First name",
  "client.profile.lastName": "Last name",
  "client.profile.photo": "Profile photo",
  "client.profile.address": "Address",
  "client.profile.phonePrimary": "Primary phone",
  "client.profile.phoneSecondary": "Additional phone",
  "client.profile.phoneInvalid": "Invalid phone format",
  "client.profile.phonesMustDiffer": "Phone numbers must differ",
  "client.profile.error.duplicatePhone": "Duplicate Phone Number",
  "client.profile.error.phoneAlreadyInUse": "This phone number ({{phone}}) is already in use by another account",
  "client.profile.edit": "Edit profile",
  "client.profile.toast.updateSuccess": "Profile updated",
  "client.profile.toast.photoUpdateSuccess": "Photo updated",
  "client.profile.toast.updateError": "Failed to update profile",
  "client.profile.subtitleExtended": "Personal information and account settings",
  "client.profile.extraPhone1": "Additional phone 1",
  "client.profile.extraPhone2": "Additional phone 2",
  "client.profile.photo.change": "Change",
  "client.profile.photo.uploading": "Uploading...",
  "client.profile.saving": "Saving...",
  "client.profile.phone.helper": "Format: +998 XX XXX XX XX",
  
  // Client pets manager extended
  "client.pets.dialog.description": "Fill in information about your pet",
  "client.pets.addNew": "Add new pet",
  "client.pets.update": "Update pet",
  "client.pets.name.label": "Name *",
  "client.pets.species.label": "Species *",
  "client.pets.gender.label": "Gender *",
  "client.pets.breed.label": "Breed",
  "client.pets.birthDate.label": "Birth date",
  "client.pets.color.label": "Color",
  "client.pets.weight.label": "Weight (kg)",
  "client.pets.notes.label": "Notes",
  "client.pets.photo.label": "Pet photo",
  "client.pets.invalidBirthDateTitle": "Invalid birth date",
  "client.pets.invalidBirthDateDescription": "Birth date cannot be in the future",
  "client.pets.toast.createDescription": "{{name}} registered successfully",
  "client.pets.toast.deleteDescription": "{{name}} removed from list",
  "client.pets.deleteConfirm": "Delete pet {{name}}?",
  "client.pets.age.label": "Age",
  "client.pets.age.yearsSuffix": "years",
  "client.pets.notes.heading": "Notes:",
  "client.pets.emptyHelp": "Add your first pet to start tracking health",
  "client.pets.creating": "Creating...",
  "client.pets.saving": "Saving...",
  "client.pets.reptile": "Reptile",
  
  // Client medical cards extended
  "client.medicalCards.subtitle": "Visit and treatment history of your pets",
  "client.medicalCards.empty": "No medical cards found",
  "client.medicalCards.column.pending": "Pending",
  "client.medicalCards.column.paid": "Paid",
  "client.medicalCards.petFallback": "Pet",
  "client.medicalCards.detailsToggle": "Details (services & prescriptions)",
  "client.medicalCards.doctor.loading": "Doctor: loading...",
  "client.medicalCards.doctor.unknown": "Doctor: unknown",
  "client.medicalCards.doctor.prefix": "Dr.",
  "client.medicalCards.assignedNurse": "Assigned Nurse",
  "client.medicalCards.assignedNurse.unknown": "Not assigned",
  
  // Nurse medical card view
  "nurse.medicalCards.assignedNurse": "Assigned Nurse",
  
  // Client dashboard banner/nav helpers
  "client.hero.fallbackRole": "Client",
  "client.dashboard.welcomeSubtitle": "Manage your pets' health in one place",
  "client.logout.goodbye": "Goodbye!",
  "client.revisit.reminder": "Tomorrow you should visit ELVET — doctor has scheduled a revisit for {{petName}} on {{date}}.",
  "client.revisit.dismiss": "Dismiss",

  // Common extra
  "common.goodbye": "Goodbye!",

  // Nurse banner & profile
  "nurse.banner.subtitle": "Patient care",
  "nurse.banner.dailySalaryLabel": "Current daily rate:",
  "nurse.banner.defaultName": "Nurse",
  "nurse.banner.changeImage": "Change",
  "nurse.banner.uploading": "Uploading...",
  "nurse.profileNotFound.title": "Nurse profile not found",
  "nurse.profileNotFound.description": "Contact the administrator for access",
  "nurse.profileNotFound.inlineWarning": "Could not determine your nurse profile. Contact the administrator to continue working with tasks.",

  // Nurse sidebar navigation
  "nurse.sidebar.navigation": "Navigation",
  "nurse.sidebar.main": "Main",
  "nurse.sidebar.procedures": "Procedures",
  "nurse.sidebar.medicalCards": "Medical Cards",
  "nurse.sidebar.nurseCare": "Nurse Care",
  "nurse.sidebar.medicines": "Medicines",
  "nurse.sidebar.schedule": "Schedule",
  "nurse.sidebar.salary": "Salary History",
  "nurse.sidebar.collapse": "Collapse sidebar",
  "nurse.sidebar.expand": "Expand sidebar",
  "nurse.sidebar.hint": "Use sidebar to navigate between sections",

  // Nurse metrics boxes
  "nurse.metrics.title": "Work metrics",
  "nurse.metrics.refresh": "Refresh",
  "nurse.metrics.salary.label": "Daily rate",
  "nurse.metrics.salary.subtitle": "Updates after completing tasks",
  "nurse.metrics.todo.label": "Tasks in progress",
  "nurse.metrics.todo.subtitle": "Awaiting completion",
  "nurse.metrics.doneToday.label": "Completed today",
  "nurse.metrics.doneToday.subtitle": "Finished today",
  "nurse.metrics.done.label": "Total completed",
  "nurse.metrics.done.subtitle": "History of completed tasks",
  "nurse.metrics.medicines.label": "Medicines in stock",
  "nurse.metrics.medicines.subtitle": "Available items",
  "nurse.metrics.pets.label": "Pets in clinic",
  "nurse.metrics.pets.subtitle": "Total registered",
  "nurse.metrics.roomsTaken.label": "Taken places",
  "nurse.metrics.roomsTaken.subtitle": "Occupied room places",

  // Nurse medicines tab
  "nurse.medicines.title": "Medicines stock",
  "nurse.medicines.description": "All medicines in database with current stock levels",
  "nurse.medicines.loading": "Updating stock data...",
  "nurse.medicines.empty": "Medicine list is empty",
  "nurse.medicines.total": "Total: {{count}}",
  "nurse.medicines.searchPlaceholder": "Search medicines by name or category...",
  "nurse.medicines.noSearchResults": "No medicines found matching your search",
  "nurse.medicines.clearSearch": "Clear search",
  "nurse.medicines.searchResults": "Showing {{count}} of {{total}} medicines",
  "nurse.medicines.table.name": "Name",
  "nurse.medicines.table.category": "Category",
  "nurse.medicines.table.stock": "Stock",
  "nurse.medicines.table.updated": "Updated",

  // Nurse schedule tab
  "nurse.schedule.title": "Procedures schedule",
  "nurse.schedule.empty": "No dated tasks found yet",
  "nurse.schedule.tasks_one": "{{count}} task",
  "nurse.schedule.tasks_other": "{{count}} tasks",
  "nurse.task.untitled": "Untitled",

  // Nurse tasks component
  "nurse.tasks.title": "Patient care tasks",
  "nurse.tasks.description": "Working list of procedures for the nurse",
  "nurse.tasks.refresh": "Refresh",
  "nurse.tasks.loading": "Loading tasks...",
  "nurse.tasks.profileMissing": "Nurse profile not found. Contact administrator.",
  "nurse.tasks.tab.todo": "In progress",
  "nurse.tasks.tab.today": "Today",
  "nurse.tasks.tab.done": "Completed",
  "nurse.tasks.empty": "List is empty",
  "nurse.tasks.table.task": "Task",
  "nurse.tasks.table.patient": "Patient",
  "nurse.tasks.table.service": "Service",
  "nurse.tasks.table.scheduled": "Scheduled",
  "nurse.tasks.table.deadline": "Deadline",
  "nurse.tasks.table.details": "Details",
  "nurse.tasks.badge.notToday": "Not today",
  "nurse.tasks.untitled": "Untitled",
  "nurse.tasks.dialog.titleFallback": "Task",
  "nurse.tasks.dialog.description": "Review task details before marking as completed.",
  "nurse.tasks.dialog.detailsNotFound": "Task details not found",
  "nurse.tasks.dialog.updatingDetails": "Updating patient and service data...",
  "nurse.tasks.dialog.patient": "Patient",
  "nurse.tasks.dialog.service": "Service",
  "nurse.tasks.dialog.scheduled": "Scheduled",
  "nurse.tasks.dialog.deadline": "Deadline",
  "nurse.tasks.dialog.descriptionLabel": "Description",
  "nurse.tasks.dialog.cardNumber": "Card #{{number}}",
  "nurse.tasks.dialog.close": "Close",
  "nurse.tasks.dialog.alreadyDone": "Task already marked completed.",
  "nurse.tasks.dialog.onlyFromTodo": "You can mark completed only from the in-progress tab.",
  "nurse.tasks.dialog.onlyToday": "Only tasks scheduled for today can be marked completed.",
  "nurse.tasks.dialog.completeButton.completed": "Already completed",
  "nurse.tasks.dialog.completeButton.markDone": "Mark completed",
  "nurse.tasks.dialog.alreadyCompletedToast": "Task already completed",
  "nurse.tasks.dialog.cannotCompleteEarlyTitle": "Cannot complete task early",
  "nurse.tasks.dialog.cannotCompleteEarlyDescription": "Only tasks scheduled for today can be marked completed.",
  "nurse.tasks.toast.done": "Task completed",
  "nurse.tasks.toast.updateError": "Failed to update task",
  "nurse.tasks.fallback.service": "Service #{{id}}",
  "nurse.tasks.fallback.medicine": "Medicine #{{id}}",
  "nurse.tasks.fallback.pet": "Pet #{{id}}",

  // Nurse Salary tab
  "nurse.tabs.salaryHistory": "Salary history",
  "nurse.salary.weeklyTitle": "Week Salary history",
  "nurse.salary.monthlyTitle": "Month Salary history",
  "nurse.salary.loading": "Loading salary history...",
  "nurse.salary.empty": "No salary events",
  "nurse.salary.table.date": "Date",
  "nurse.salary.table.amount": "Amount",

  // Moderator dashboard - additional strings
  "moderator.banner.subtitle": "Clinic moderator panel",
  "moderator.banner.fallbackRole": "Moderator",
  "moderator.banner.changeImage": "Change",
  "moderator.banner.uploading": "Uploading…",
  "moderator.tabs.clients": "Clients",
  "moderator.tabs.addUser": "Add user",
  "moderator.tabs.nurseCare": "Nurse Care",
  "moderator.tabs.feedSales": "Feed sales",
  "moderator.tabs.feedInventory": "Feed inventory",
  "moderator.clients.title": "Clients",
  "moderator.clients.subtitle": "List of all clinic clients",
  "moderator.clients.filter.id": "Client ID",
  "moderator.clients.filter.idPlaceholder": "e.g.: 123",
  "moderator.clients.filter.name": "First or last name",
  "moderator.clients.filter.namePlaceholder": "Client first or last name",
  "moderator.clients.filter.phone": "Phone",
  "moderator.clients.filter.phonePlaceholder": "Search by phone",
  "moderator.clients.table.id": "ID",
  "moderator.clients.table.firstName": "First name",
  "moderator.clients.table.lastName": "Last name",
  "moderator.clients.table.phone": "Phone",
  "moderator.clients.table.extraPhone1": "Extra phone 1",
  "moderator.clients.table.extraPhone2": "Extra phone 2",
  "moderator.clients.empty": "No clients to display",
  "moderator.addUser.title": "Register new client",
  "moderator.addUser.subtitle": "Create a client by specifying phone and password. First and last name are optional.",
  "moderator.addUser.phone": "Phone",
  "moderator.addUser.phonePlaceholder": "+998901234567",
  "moderator.addUser.password": "Password",
  "moderator.addUser.passwordPlaceholder": "Minimum 6 characters",
  "moderator.addUser.passwordShow": "Show password",
  "moderator.addUser.passwordHide": "Hide password",
  "moderator.addUser.firstName": "First name (optional)",
  "moderator.addUser.lastName": "Last name (optional)",
  "moderator.addUser.submit": "Create client",
  "moderator.addUser.phoneInvalid": "Invalid phone format",
  "moderator.addUser.phoneUsed": "This number is already in use",
  "moderator.addUser.checkingPhone": "Checking number…",
  "moderator.addUser.validation.required": "Check fields",
  "moderator.addUser.validation.requiredDesc": "Phone and password are required",
  "moderator.addUser.validation.phoneInvalid": "Phone is incorrect",
  "moderator.addUser.validation.phoneInvalidDesc": "Check phone number",
  "moderator.addUser.success": "Client created",
  "moderator.addUser.error": "Error",
  "moderator.addUser.errorDesc": "Failed to create client",
  "moderator.visits.create.client": "Client",
  "moderator.visits.create.clientPlaceholder": "Select client",
  "moderator.visits.create.doctor": "Doctor",
  "moderator.visits.create.doctorPlaceholder": "Select doctor",
  "moderator.visits.create.pet": "Pet",
  "moderator.visits.create.petPlaceholder": "Select pet",
  "moderator.visits.create.validation": "Check fields",
  "moderator.visits.create.validationDesc": "Select client and doctor",
  "moderator.visits.create.success": "Visit created",
  "moderator.visits.create.error": "Error",
  "moderator.visits.create.errorDesc": "Failed to create visit",
  "moderator.visits.table.date": "Date",
  "moderator.visits.table.client": "Client",
  "moderator.visits.table.doctor": "Doctor",
  "moderator.visits.table.pet": "Pet",
  "moderator.requests.table.id": "ID",
  "moderator.requests.table.firstName": "First name",
  "moderator.requests.table.lastName": "Last name",
  "moderator.requests.table.phone": "Phone",
  "moderator.requests.table.created": "Created",
  "moderator.card.table.id": "ID",
  "moderator.card.table.client": "Client",
  "moderator.card.table.pet": "Pet",
  "moderator.card.table.amount": "Amount",
  "moderator.card.table.status": "Status",
  "moderator.card.table.actions": "Actions",
  "moderator.card.partlyPaid.title": "Partly paid cards",
  "moderator.card.partlyPaid.status": "Status: PARTLY_PAID",
  "moderator.card.partlyPaid.table.total": "Total",
  "moderator.card.partlyPaid.table.paid": "Paid",
  "moderator.card.partlyPaid.table.outstanding": "Outstanding",
  "moderator.card.modal.paid": "Paid",
  "moderator.card.modal.outstanding": "Outstanding amount",
  "moderator.card.modal.progress": "Payment progress",
  "moderator.card.modal.anamnesis": "Anamnesis",
  "moderator.card.modal.recommendedFeed": "Doctor recommended feed",
  "moderator.card.modal.feeTotal": "Total (total_fee)",
  "moderator.card.modal.feeStationary": "Stationary (stationary_fee)",
  "moderator.card.modal.feeMedicines": "Medicines (medicines_fee)",
  "moderator.card.modal.feeServices": "Services (services_fee)",
  "moderator.card.modal.servicesTitle": "Used services",
  "moderator.card.modal.servicesTable.service": "Service",
  "moderator.card.modal.servicesTable.quantity": "Qty",
  "moderator.card.modal.servicesTable.price": "Price",
  "moderator.card.modal.servicesTable.total": "Total",
  "moderator.card.modal.medicinesTitle": "Used medicines",
  "moderator.card.modal.medicinesTable.medicine": "Medicine",
  "moderator.card.modal.medicinesTable.quantity": "Qty",
  "moderator.card.modal.medicinesTable.price": "Price",
  "moderator.card.modal.medicinesTable.total": "Total",
  "moderator.card.modal.paymentsTitle": "Payments",
  "moderator.card.modal.paymentsTable.date": "Date",
  "moderator.card.modal.paymentsTable.method": "Method",
  "moderator.card.modal.paymentsTable.amount": "Amount",
  "moderator.card.modal.paymentsTable.note": "Note",
  "moderator.card.modal.paymentsTable.recordedBy": "Recorded by",
  "moderator.card.modal.paymentsEmpty": "No payments yet",
  "moderator.card.modal.paymentAmount": "Payment amount",
  "moderator.card.modal.paymentMethod": "Payment method",
  "moderator.card.modal.paymentMethod.cash": "Cash",
  "moderator.card.modal.paymentMethod.card": "By Card",
  "moderator.card.modal.paymentMethod.transfer": "Transfer",
  // Legacy keys for backward compatibility
  "moderator.card.modal.paymentMethod.click": "Click",
  "moderator.card.modal.paymentMethod.payme": "Payme",
  "moderator.card.modal.paymentMethod.other": "Other",
  "moderator.card.modal.paymentNote": "Note (optional)",
  "moderator.card.modal.paymentNotePlaceholder": "e.g.: first payment installment",
  "moderator.card.modal.confirmFullPayment": "Fully paid",
  "moderator.card.modal.acceptPartialPayment": "Accept partial payment",
  "moderator.card.modal.paymentValidation.amountRequired": "Invalid amount",
  "moderator.card.modal.paymentValidation.amountRequiredDesc": "Enter amount greater than zero",
  "moderator.card.modal.paymentValidation.amountExceeds": "Amount exceeds balance",
  "moderator.card.modal.paymentValidation.methodRequired": "Payment method",
  "moderator.card.modal.paymentValidation.methodRequiredDesc": "Select payment method",
  "moderator.card.modal.paymentSuccess": "Payment accepted",
  "moderator.card.modal.paymentError": "Payment error",
  "moderator.errors.loadCards": "Failed to load cards",
  "moderator.errors.loadItems": "Failed to load card items",
  "moderator.errors.loadPayments": "Failed to load payments",
  "moderator.errors.loadVisits": "Failed to load visits",
  "moderator.errors.loadClients": "Failed to load clients",
  "moderator.errors.loadRequests": "Failed to load requests",
  "moderator.errors.updatePhoto": "Failed to update photo",
  "moderator.errors.updatePhotoDesc": "Failed to update photo",
  "moderator.photo.updated": "Photo updated",
  "moderator.kpi.quantityGreaterThanZero": "quantity > 0",
  "moderator.select.loading": "Loading…",
  "moderator.select.client": "Select client",
  "moderator.select.doctor": "Select doctor",
  "moderator.select.pet": "Select pet",

  // Client dashboard - Nurse Care tab
  "client.tabs.nurseCare": "Nurse Cards",
  "client.tabs.nurseCareShort": "Cards",
  "client.tabs.historyCards": "History Cards",
  "client.tabs.historyCardsShort": "History",

  // Nurse dashboard - Nurse Care tab
  "nurse.tabs.nurseCare": "Nurse Care 💗",
  "nurse.tabs.nurseCareShort": "Nurse 💗",
  "nurse.medicines.itemFallback": "Item #{{id}}",
  "nurse.medicines.untitled": "Untitled",

  // Admin dashboard
  "admin.banner.goHome": "Back to home",
  "admin.message.useAdminPanel": "Use the ELVET admin panel to manage the system.",
  "admin.message.urlNotConfigured": "Admin panel URL is not configured. Contact the developer.",
  "admin.button.openAdmin": "ELVET ADMIN",

  // Doctor dashboard - feed recommendation placeholder
  "doctor.feed.recommendationPlaceholder": "e.g.: JOSERA Catelux, 0.5 kg per day for 14 days",
  "doctor.edit.attachments.add": "Add attachments",

  // Client PetsManager - animal type labels
  "client.pets.animalType.dog": "🐕 Dog",
  "client.pets.animalType.cat": "🐈 Cat",
  "client.pets.animalType.bird": "🦜 Bird",
  "client.pets.animalType.other": "🐾 Other",
  "client.pets.colorPlaceholder": "Ginger",
  "client.pets.descriptionPlaceholder": "Special features, allergies...",

  // Client MedicalCardsViewer - column headers and labels
  "client.medicalCards.column.waiting": "Waiting for Payment",
  "client.medicalCards.column.partlyPaid": "Partly Paid",
  "client.medicalCards.column.fullyPaid": "Fully Paid",
  "client.medicalCards.currency.sum": "UZS",
  "client.medicalCards.attachments": "Attachments",
  "client.medicalCards.attachments.downloadAll": "Download all",
  "client.medicalCards.attachments.download": "Download",
  "client.medicalCards.attachments.xrays": "X-rays",
  "client.medicalCards.attachments.files": "Files",
  "client.medicalCards.attachments.open": "Open",
  "client.medicalCards.attachments.openFile": "Open",

  // Client NurseCareCardsViewer
  "client.nurseCare.title": "Nurse Cards",
  "client.nurseCare.subtitle": "Read-only view of your nurse care history",
  "client.nurseCare.loading": "Loading…",
  "client.nurseCare.error": "Failed to load",
  "client.nurseCare.empty": "No nurse care cards yet",
  "client.nurseCare.column.waiting": "Waiting for Payment",
  "client.nurseCare.column.partlyPaid": "Partly Paid",
  "client.nurseCare.column.fullyPaid": "Fully Paid",
  "client.nurseCare.status.waiting": "Waiting for Payment",
  "client.nurseCare.status.partlyPaid": "Partly Paid",
  "client.nurseCare.status.fullyPaid": "Fully Paid",
  "client.nurseCare.cardNumber": "Card #{{id}}",
  "client.nurseCare.nurseNumber": "Nurse #{{id}}",
  "client.nurseCare.servicesEmpty": "No services",
  "client.nurseCare.total": "Total:",
  "client.nurseCare.paid": "Paid:",
  "client.nurseCare.remain": "Remain:",

  // Client HistoryCardsViewer (unified medical + nurse cards)
  "client.historyCards.title": "History Cards",
  "client.historyCards.subtitle": "All medical and nurse care records in one place",
  "client.historyCards.filterByStatus": "Filter by payment status",
  "client.historyCards.status.waiting": "Waiting for Payment",
  "client.historyCards.status.waitingShort": "Waiting",
  "client.historyCards.status.partlyPaid": "Partly Paid",
  "client.historyCards.status.partlyPaidShort": "Partly",
  "client.historyCards.status.fullyPaid": "Fully Paid",
  "client.historyCards.status.fullyPaidShort": "Paid",
  "client.historyCards.badge.medical": "Medical",
  "client.historyCards.badge.medicalShort": "Med",
  "client.historyCards.badge.nurseCare": "Nurse Care",
  "client.historyCards.badge.nurseCareShort": "Nurse",
  "client.historyCards.empty": "No cards found",
  "client.historyCards.emptyHint": "Try selecting a different payment status",

  // Moderator NurseCareCardsManager
  "moderator.nurseCare.title": "Nurse Care Cards",
  "moderator.nurseCare.description": "Create cards and record payments.",
  "moderator.nurseCare.allCards": "All Cards",
  "moderator.nurseCare.refresh": "Refresh",
  "moderator.nurseCare.loading": "Loading…",
  "moderator.nurseCare.noCards": "No cards",
  "moderator.nurseCare.cardNumber": "Card #{{id}}",
  "moderator.nurseCare.paidInfo": "Paid {{paid}} / {{total}} · Remain {{remain}}",
  "moderator.nurseCare.createCard": "Create Card",
  "moderator.nurseCare.client": "Client",
  "moderator.nurseCare.selectClient": "Select client",
  "moderator.nurseCare.pet": "Pet",
  "moderator.nurseCare.selectPet": "Select pet",
  "moderator.nurseCare.nurse": "Nurse",
  "moderator.nurseCare.selectNurse": "Select nurse",
  "moderator.nurseCare.descriptionLabel": "Description",
  "moderator.nurseCare.descriptionPlaceholder": "Optional",
  "moderator.nurseCare.create": "Create",
  "moderator.nurseCare.recordPayment": "Record Payment",
  "moderator.nurseCare.selectCardMessage": "Select a card to record a payment.",
  "moderator.nurseCare.total": "Total:",
  "moderator.nurseCare.paid": "Paid:",
  "moderator.nurseCare.remain": "Remain:",
  "moderator.nurseCare.amount": "Amount",
  "moderator.nurseCare.amountPlaceholder": "e.g. 40000",
  "moderator.nurseCare.method": "Method",
  "moderator.nurseCare.selectMethod": "Select method",
  "moderator.nurseCare.record": "Record",
  "moderator.nurseCare.errors.loadFailed": "Failed to load cards",
  "moderator.nurseCare.errors.missingFields": "Missing fields",
  "moderator.nurseCare.errors.selectClientPetNurse": "Select client and nurse",
  "moderator.nurseCare.success.created": "Created",
  "moderator.nurseCare.success.createdDesc": "Nurse care card created",
  "moderator.nurseCare.errors.createFailed": "Failed to create",
  "moderator.nurseCare.errors.enterAmountMethod": "Enter amount and method",
  "moderator.nurseCare.success.recorded": "Recorded",
  "moderator.nurseCare.success.recordedDesc": "Payment recorded",
  "moderator.nurseCare.errors.recordFailed": "Failed to record payment",

  // Client ProfileEditor - phone placeholder
  "client.profile.phonePlaceholder": "+998 90 123 45 67",
  "client.profile.nameSeparator": ":",

  // Moderator sidebar navigation
  "moderator.sidebar.navigation": "Navigation",
  "moderator.sidebar.main": "Main",
  "moderator.sidebar.medicalCards": "Medical Cards",
  "moderator.sidebar.visits": "Visits",
  "moderator.sidebar.requests": "Requests",
  "moderator.sidebar.clients": "Clients",
  "moderator.sidebar.addClient": "Add Client",
  "moderator.sidebar.nurseCare": "Nurse Care",
  "moderator.sidebar.feedSales": "Feed Sales",
  "moderator.sidebar.feedInventory": "Feed Inventory",
  "moderator.sidebar.medicines": "Medicine storage",
  "moderator.sidebar.staffIncome": "Staff Income",
  "moderator.sidebar.collapse": "Collapse",
  "moderator.sidebar.expand": "Expand",
  "moderator.sidebar.hint": "Reception Dashboard",

  // Moderator staff income dashboard
  "moderator.staffIncome.title": "Staff Income & Payments",
  "moderator.staffIncome.description": "Daily earnings for doctors and nurses",
  "moderator.staffIncome.date": "Date",
  "moderator.staffIncome.search": "Search",
  "moderator.staffIncome.searchPlaceholder": "Search by name or ID...",
  "moderator.staffIncome.filterRole": "Filter by role",
  "moderator.staffIncome.allRoles": "All Roles",
  "moderator.staffIncome.doctors": "Doctors",
  "moderator.staffIncome.nurses": "Nurses",
  "moderator.staffIncome.refresh": "Refresh",
  "moderator.staffIncome.go": "Apply",
  "moderator.staffIncome.totalStaff": "Total Staff",
  "moderator.staffIncome.totalEarned": "Total Earned",
  "moderator.staffIncome.paidOut": "Paid Out",
  "moderator.staffIncome.pendingPay": "Pending Payment",
  "moderator.staffIncome.col.id": "ID",
  "moderator.staffIncome.col.name": "Name",
  "moderator.staffIncome.col.role": "Role",
  "moderator.staffIncome.col.earned": "Earned",
  "moderator.staffIncome.col.status": "Status",
  "moderator.staffIncome.col.action": "Action",
  "moderator.staffIncome.role.doctor": "Doctor",
  "moderator.staffIncome.role.nurse": "Nurse",
  "moderator.staffIncome.status.paid": "Paid",
  "moderator.staffIncome.status.unpaid": "Unpaid",
  "moderator.staffIncome.pay": "Pay",
  "moderator.staffIncome.paying": "Paying...",
  "moderator.staffIncome.alreadyPaid": "Paid",
  "moderator.staffIncome.empty.noData": "No salary data for this date",
  "moderator.staffIncome.empty.noMatch": "No staff match your filters",
  "moderator.staffIncome.paySuccess": "Payment recorded",
  "moderator.staffIncome.payError": "Payment error",
  "moderator.staffIncome.loadError": "Failed to load data",

  // Medicine storage
  "storage.title": "Medicine storage",
  "storage.adminIntro": "Receipts, write-offs, stock counts and prices. Everything doctors use is taken from storage automatically.",
  "storage.subtitleView": "What is in storage right now",
  "storage.add": "Add medicine",
  "storage.searchPlaceholder": "Search medicine…",
  "storage.loadError": "Could not load storage",
  "storage.retry": "Retry",
  "storage.note": "Note",
  "storage.summary.total": "Items",
  "storage.summary.out": "Out of stock",
  "storage.summary.low": "Running low",
  "storage.summary.expiring": "Expires ≤ {{days}} days",
  "storage.summary.expired": "Has expired stock",
  "storage.summary.noPrice": "No price",
  "storage.filter.allTypes": "All types",
  "storage.filter.showInactive": "Show inactive",
  "storage.table.name": "Medicine",
  "storage.table.stock": "In stock",
  "storage.table.price": "Selling price",
  "storage.table.expiry": "Nearest expiry",
  "storage.table.actions": "Actions",
  "storage.status.out": "Out of stock",
  "storage.status.low": "Low",
  "storage.status.inactive": "Inactive",
  "storage.status.noPrice": "No price set",
  "storage.status.expired": "Expired",
  "storage.status.expiredQty": "Expired: {{qty}}",
  "storage.actions.receive": "Receive",
  "storage.actions.writeOff": "Write off",
  "storage.actions.count": "Stock count",
  "storage.actions.history": "History & batches",
  "storage.actions.edit": "Edit",
  "storage.unit.PIECE": "pcs",
  "storage.unit.TABLET": "tab",
  "storage.unit.CAPSULE": "caps",
  "storage.unit.AMPOULE": "amp",
  "storage.unit.SACHET": "sachet",
  "storage.unit.ML": "ml",
  "storage.unit.MG": "mg",
  "storage.unit.G": "g",
  "storage.unitName.PIECE": "Piece",
  "storage.unitName.TABLET": "Tablet / caplet",
  "storage.unitName.CAPSULE": "Capsule",
  "storage.unitName.AMPOULE": "Ampoule",
  "storage.unitName.SACHET": "Sachet",
  "storage.unitName.ML": "Millilitre (ml)",
  "storage.unitName.MG": "Milligram (mg)",
  "storage.unitName.G": "Gram (g)",
  "storage.package.PIECE": "pcs",
  "storage.package.PACK": "pack",
  "storage.package.BLISTER": "blister",
  "storage.package.VIAL": "vial",
  "storage.package.BOTTLE": "bottle",
  "storage.package.TUBE": "tube",
  "storage.packageName.PIECE": "Piece",
  "storage.packageName.PACK": "Pack / box",
  "storage.packageName.BLISTER": "Blister",
  "storage.packageName.VIAL": "Vial",
  "storage.packageName.BOTTLE": "Bottle",
  "storage.packageName.TUBE": "Tube",
  "storage.form.createTitle": "New medicine",
  "storage.form.editTitle": "Edit medicine",
  "storage.form.subtitle": "Choose how the medicine is used up — stock and price follow from it.",
  "storage.form.name": "Name",
  "storage.form.namePlaceholder": "e.g. Synulox 50 mg",
  "storage.form.type": "Stock type",
  "storage.form.types.WHOLE.title": "Whole item",
  "storage.form.types.WHOLE.hint": "Sold only whole: paste, collar, syringe, spray.",
  "storage.form.types.COUNTABLE.title": "Units in a pack",
  "storage.form.types.COUNTABLE.hint": "Tablets, capsules, ampoules. Part of a pack can be sold.",
  "storage.form.types.MEASURED.title": "Liquid / by weight",
  "storage.form.types.MEASURED.hint": "Counted in ml, mg or g. The doctor takes what is needed, the rest stays.",
  "storage.form.unitLocked": "Type and unit are locked while the item has stock or history.",
  "storage.form.unit": "Base unit",
  "storage.form.packageUnit": "Package",
  "storage.form.packageSize": "{{unit}} per {{package}}",
  "storage.form.price": "Selling price, sum",
  "storage.form.pricePer": "Price is for how many {{unit}}",
  "storage.form.doseStep": "Smallest portion",
  "storage.form.doseStepHint": "Doctors dispense in multiples of this step (e.g. ½ tablet or 0.01 ml).",
  "storage.form.example": "Example: doctor uses {{qty}} → client pays {{price}}",
  "storage.form.minStock": "Warn when stock is ≤ ({{unit}})",
  "storage.form.minStockHint": "0 — no warning",
  "storage.form.active": "In use",
  "storage.form.description": "Description",
  "storage.form.errorName": "Enter a name",
  "storage.form.errorPrice": "Enter a price",
  "storage.form.created": "Medicine added",
  "storage.form.updated": "Changes saved",
  "storage.form.saveError": "Could not save",
  "storage.receive.title": "Receive stock",
  "storage.receive.packages": "Whole {{package}} ({{size}} each)",
  "storage.receive.quantity": "Quantity, {{unit}}",
  "storage.receive.loose": "Plus loose, {{unit}}",
  "storage.receive.total": "Will be added",
  "storage.receive.expireDate": "Expiry date",
  "storage.receive.batchNumber": "Batch no.",
  "storage.receive.purchasePrice": "Purchase price per {{package}}",
  "storage.receive.submit": "Receive",
  "storage.receive.done": "Added {{qty}}",
  "storage.receive.error": "Could not receive stock",
  "storage.receive.errorEmpty": "Enter a quantity",
  "storage.writeOff.title": "Write off",
  "storage.writeOff.batch": "Batch",
  "storage.writeOff.batchAuto": "Automatic (oldest first)",
  "storage.writeOff.batchOption": "exp. {{expiry}} — {{qty}}",
  "storage.writeOff.quantity": "Quantity, {{unit}}",
  "storage.writeOff.reason": "Reason",
  "storage.writeOff.submit": "Write off",
  "storage.writeOff.done": "Wrote off {{qty}}",
  "storage.writeOff.error": "Could not write off",
  "storage.reason.EXPIRED": "Expired",
  "storage.reason.DAMAGED": "Damaged / broken",
  "storage.reason.LOST": "Lost",
  "storage.reason.OTHER": "Other",
  "storage.adjust.title": "Stock count",
  "storage.adjust.subtitle": "Count {{name}} on the shelf and enter the real amount.",
  "storage.adjust.inSystem": "In the system",
  "storage.adjust.counted": "Counted, {{unit}}",
  "storage.adjust.difference": "Difference: {{qty}}",
  "storage.adjust.noDifference": "No difference",
  "storage.adjust.done": "Stock corrected",
  "storage.adjust.error": "Could not save",
  "storage.history.batches": "Batches",
  "storage.history.journal": "Movement journal",
  "storage.history.noBatches": "No stock left",
  "storage.history.noMovements": "No movements yet",
  "storage.history.received": "Received",
  "storage.history.expiry": "Expires",
  "storage.history.remaining": "Left / received",
  "storage.history.cost": "Cost",
  "storage.history.when": "When",
  "storage.history.operation": "Operation",
  "storage.history.quantity": "Quantity",
  "storage.history.details": "Details",
  "storage.history.who": "Who",
  "storage.history.card": "Card #{{id}}",
  "storage.kind.RECEIPT": "Receipt",
  "storage.kind.DISPENSE": "Dispensed",
  "storage.kind.RETURN": "Returned",
  "storage.kind.WRITE_OFF": "Write-off",
  "storage.kind.ADJUSTMENT": "Count adjustment",
  "storage.dose.add": "Add medicine",
  "storage.dose.noLines": "No medicines added",
  "storage.dose.inStock": "In storage",
  "storage.dose.notePlaceholder": "How to give (IM, twice a day…)",
  "storage.dose.total": "Medicines total",
  "storage.dose.errorPositive": "Enter a quantity above zero",
  "storage.dose.errorStep": "Quantity must be a multiple of {{step}}",
  "storage.dose.errorStock": "Only {{available}} in storage",
  "storage.dose.errorNoPrice": "This medicine has no price",
  "storage.dose.fixErrors": "Check the medicines",
  "storage.dose.saveFailed": "Some medicines were not saved",

  // Admin panel
  "adminPanel.title": "Admin panel",
  "adminPanel.menu": "Menu",
  "adminPanel.refresh": "Refresh",
  "adminPanel.refreshing": "Refreshing…",
  "adminPanel.group.main": "Main",
  "adminPanel.group.money": "Money",
  "adminPanel.group.people": "People",
  "adminPanel.group.catalog": "Storage & prices",
  "adminPanel.nav.overview": "Overview",
  "adminPanel.nav.cards": "Medical cards",
  "adminPanel.nav.finance": "Finance",
  "adminPanel.nav.salaries": "Salaries",
  "adminPanel.nav.staff": "Staff",
  "adminPanel.nav.clients": "Clients",
  "adminPanel.nav.requests": "Website requests",
  "adminPanel.nav.storage": "Medicine storage",
  "adminPanel.nav.services": "Services & prices",
  "adminPanel.nav.stationary": "Inpatient stay",
  "adminPanel.nav.feeds": "Pet food",
  "adminPanel.nav.doctor": "Doctor workspace",
  "adminPanel.nav.django": "Advanced admin",
  "adminPanel.common.add": "Add",
  "adminPanel.common.edit": "Edit",
  "adminPanel.common.actions": "Actions",
  "adminPanel.common.search": "Search…",
  "adminPanel.common.total": "Total: {{count}}",
  "adminPanel.common.loadError": "Could not load data",
  "adminPanel.common.saved": "Saved",
  "adminPanel.common.saveError": "Could not save",
  "adminPanel.common.deleted": "Deleted",
  "adminPanel.common.deleteError": "Could not delete",
  "adminPanel.common.deleteTitle": "Delete this record?",
  "adminPanel.common.deleteText": "This cannot be undone.",
  "adminPanel.common.required": "Fill in “{{field}}”",
  "adminPanel.common.passwordKeep": "Leave empty to keep",
  "adminPanel.common.on": "Active",
  "adminPanel.common.off": "Off",
  "adminPanel.fields.name": "Name",
  "adminPanel.fields.firstName": "First name",
  "adminPanel.fields.lastName": "Last name",
  "adminPanel.fields.phone": "Phone",
  "adminPanel.fields.extraPhone": "Extra phone",
  "adminPanel.fields.password": "Password",
  "adminPanel.fields.passwordHint": "At least 6 characters. When editing, sets a new password.",
  "adminPanel.fields.status": "Status",
  "adminPanel.fields.specialization": "Specialization",
  "adminPanel.fields.experience": "Experience, years",
  "adminPanel.fields.workStart": "Start date",
  "adminPanel.fields.fixedSalary": "Fixed salary",
  "adminPanel.fields.description": "Description",
  "adminPanel.fields.address": "Address",
  "adminPanel.fields.registered": "Registered",
  "adminPanel.fields.price": "Price",
  "adminPanel.fields.date": "Date",
  "adminPanel.fields.doctor": "Doctor",
  "adminPanel.overview.period": "Period",
  "adminPanel.overview.days": "{{count}} days",
  "adminPanel.overview.income": "Income",
  "adminPanel.overview.expenses": "Expenses",
  "adminPanel.overview.net": "Net profit",
  "adminPanel.overview.unpaid": "Unpaid by clients",
  "adminPanel.overview.cards": "Medical cards",
  "adminPanel.overview.newClients": "New clients",
  "adminPanel.overview.today": "Today: {{value}}",
  "adminPanel.overview.thisMonth": "This month: {{value}}",
  "adminPanel.overview.unpaidCards": "Unpaid cards: {{count}}",
  "adminPanel.overview.todayCount": "Today: {{count}}",
  "adminPanel.overview.clientsTotal": "Total clients: {{count}}",
  "adminPanel.overview.attention": "Needs attention:",
  "adminPanel.overview.alertOut": "Out of stock: {{count}}",
  "adminPanel.overview.alertLow": "Running low: {{count}}",
  "adminPanel.overview.alertExpiring": "Expiring soon: {{count}}",
  "adminPanel.overview.alertUnpaid": "Unpaid cards: {{count}}",
  "adminPanel.overview.alertRequests": "Requests: {{count}}",
  "adminPanel.overview.dailyTitle": "Income and expenses by day",
  "adminPanel.overview.dailyHint": "All clinic receipts and recorded expenses",
  "adminPanel.overview.monthlyTitle": "Last 12 months",
  "adminPanel.overview.monthlyHint": "Income and expenses by month",
  "adminPanel.overview.cardsTitle": "Medical cards per day",
  "adminPanel.overview.cardsHint": "How many visits each day",
  "adminPanel.overview.methodsTitle": "Payment methods",
  "adminPanel.overview.methodsHint": "Card and nurse-care payments in the period",
  "adminPanel.overview.servicesTitle": "Top services by revenue",
  "adminPanel.overview.servicesHint": "Top 8 in the period",
  "adminPanel.overview.medicinesTitle": "Top medicines",
  "adminPanel.overview.medicinesHint": "By revenue in the period",
  "adminPanel.overview.doctorsTitle": "Doctors' performance",
  "adminPanel.overview.doctorsHint": "Cards, billed amount and doctor earnings in the period",
  "adminPanel.overview.revenue": "Revenue",
  "adminPanel.overview.earned": "Doctor earned",
  "adminPanel.overview.used": "Used",
  "adminPanel.overview.noData": "No data for this period",
  "adminPanel.cards.hint": "All clinic cards. Click a row to open it and take a payment.",
  "adminPanel.cards.search": "Search: no., client, pet, doctor",
  "adminPanel.cards.allStatuses": "All statuses",
  "adminPanel.cards.status.OPEN": "Open",
  "adminPanel.cards.status.WAITING_FOR_PAYMENT": "Awaiting payment",
  "adminPanel.cards.status.PARTLY_PAID": "Partly paid",
  "adminPanel.cards.status.FULLY_PAID": "Paid",
  "adminPanel.cards.card": "Card",
  "adminPanel.cards.client": "Client",
  "adminPanel.cards.pet": "Pet",
  "adminPanel.cards.total": "Total",
  "adminPanel.cards.debt": "Owed",
  "adminPanel.cards.services": "Services",
  "adminPanel.cards.medicines": "Medicines",
  "adminPanel.cards.stationary": "Inpatient",
  "adminPanel.cards.anamnez": "History",
  "adminPanel.cards.diagnosis": "Diagnosis",
  "adminPanel.cards.prescriptions": "Prescriptions",
  "adminPanel.cards.payments": "Payments",
  "adminPanel.cards.noPayments": "No payments yet",
  "adminPanel.cards.paidSoFar": "Paid",
  "adminPanel.cards.receive": "Take a payment",
  "adminPanel.cards.receiveButton": "Receive",
  "adminPanel.cards.paid": "Received {{amount}}",
  "adminPanel.cards.payError": "Could not record the payment",
  "adminPanel.finance.day": "Day",
  "adminPanel.finance.month": "Month",
  "adminPanel.finance.year": "Year",
  "adminPanel.finance.income": "Income",
  "adminPanel.finance.expenses": "Expenses",
  "adminPanel.finance.net": "Net profit",
  "adminPanel.finance.expensesTab": "Expenses",
  "adminPanel.finance.paymentsTab": "Payment history",
  "adminPanel.finance.expensesHint": "Rent, utilities, purchases. Salaries are added automatically when paid.",
  "adminPanel.finance.paymentsHint": "Every payment on medical cards",
  "adminPanel.finance.addExpense": "Add expense",
  "adminPanel.finance.amount": "Amount",
  "adminPanel.finance.categoryLabel": "Category",
  "adminPanel.finance.methodLabel": "Method",
  "adminPanel.finance.note": "Note",
  "adminPanel.finance.method.CASH": "Cash",
  "adminPanel.finance.method.CARD": "Card",
  "adminPanel.finance.method.TRANSFER": "Transfer",
  "adminPanel.finance.category.SALARY": "Salary",
  "adminPanel.finance.category.MEDICINE": "Medicine purchase",
  "adminPanel.finance.category.FEED": "Food purchase",
  "adminPanel.finance.category.RENT": "Rent",
  "adminPanel.finance.category.UTILITIES": "Utilities",
  "adminPanel.finance.category.EQUIPMENT": "Equipment",
  "adminPanel.finance.category.OTHER": "Other",
  "adminPanel.staff.doctors": "Doctors",
  "adminPanel.staff.nurses": "Nurses",
  "adminPanel.staff.moderators": "Front desk",
  "adminPanel.staff.hint": "To lock out someone who left, switch off “Can log in”.",
  "adminPanel.staff.addDoctor": "Add doctor",
  "adminPanel.staff.addNurse": "Add nurse",
  "adminPanel.staff.addModerator": "Add front-desk staff",
  "adminPanel.staff.active": "Active",
  "adminPanel.staff.inactive": "No access",
  "adminPanel.staff.vacation": "On vacation",
  "adminPanel.staff.canLogin": "Can log in",
  "adminPanel.staff.onVacation": "On vacation",
  "adminPanel.staff.earnedToday": "Earned today",
  "adminPanel.clients.hint": "Pet owners. You can set a new password when editing.",
  "adminPanel.clients.add": "Add client",
  "adminPanel.services.hint": "Service price list and the doctor / nurse share of each service.",
  "adminPanel.services.add": "Add service",
  "adminPanel.services.doctorShare": "Doctor share",
  "adminPanel.services.nurseShare": "Nurse share",
  "adminPanel.services.sharePercent": "Doctor share, %",
  "adminPanel.services.shareFixed": "Or a fixed amount to the doctor",
  "adminPanel.services.shareHint": "If a % is set, the percentage is used.",
  "adminPanel.services.nursePercent": "Nurse share, %",
  "adminPanel.services.rates": "Doctor rates",
  "adminPanel.services.ratesTitle": "Individual rates: {{name}}",
  "adminPanel.services.ratesHint": "By default a doctor gets {{share}}. Set a different share for a specific doctor here.",
  "adminPanel.stationary.hint": "Inpatient rates the doctor picks on a medical card.",
  "adminPanel.stationary.add": "Add rate",
  "adminPanel.stationary.period": "Period",
  "adminPanel.stationary.amount": "Length",
  "adminPanel.stationary.unit": "Unit",
  "adminPanel.stationary.hour": "h",
  "adminPanel.stationary.day": "days",
  "adminPanel.feeds.hint": "Food sold at the front desk. Stock in kg goes down with each sale.",
  "adminPanel.feeds.add": "Add food",
  "adminPanel.feeds.brand": "Brand",
  "adminPanel.feeds.product": "Product",
  "adminPanel.feeds.factory": "Manufacturer",
  "adminPanel.feeds.animal": "Animal",
  "adminPanel.feeds.age": "Age",
  "adminPanel.feeds.dog": "Dog",
  "adminPanel.feeds.cat": "Cat",
  "adminPanel.feeds.junior": "Junior",
  "adminPanel.feeds.adult": "Adult",
  "adminPanel.feeds.senior": "Senior",
  "adminPanel.feeds.packageKg": "Package weight, kg",
  "adminPanel.feeds.pricePerKg": "Price per kg",
  "adminPanel.feeds.inStock": "In stock",
  "adminPanel.feeds.inStockKg": "In stock, kg",
  "adminPanel.requests.hint": "Requests sent through the website form.",
  "adminPanel.requests.message": "Message",
  "storage.currency": "UZS",
  "storage.form.stepWhat": "What is it",
  "storage.form.stepPackage": "Packaging",
  "storage.form.stepPrice": "Selling price",
  "storage.form.stepInitial": "Stock received now",
  "storage.form.initialHint": "Optional. If it's already on the shelf, enter the amount and it goes straight into storage.",
  "storage.form.stepOther": "Extra settings",
  "storage.form.initialFailed": "Medicine added, but the stock was not saved — use “Receive”",

  // Feed sales
  "feedSales.title": "Pet food sales",
  "feedSales.subtitle": "Sell food to anyone — a clinic client or a walk-in buyer.",
  "feedSales.new": "New sale",
  "feedSales.newTitle": "Sell pet food",
  "feedSales.newHint": "Enter the buyer, what they take and how they pay. The price is calculated automatically.",
  "feedSales.buyer": "Buyer",
  "feedSales.mode.walkin": "Walk-in buyer",
  "feedSales.mode.walkinHint": "Not a clinic client — just first and last name. Pays right away.",
  "feedSales.mode.client": "Clinic client",
  "feedSales.mode.clientHint": "A registered client. Can pay later.",
  "feedSales.firstName": "First name",
  "feedSales.lastName": "Last name",
  "feedSales.pickClient": "Choose a client…",
  "feedSales.searchClient": "Name or phone",
  "feedSales.whatBought": "What was bought",
  "feedSales.feed": "Food",
  "feedSales.pickFeed": "Choose food",
  "feedSales.left": "{{kg}} left",
  "feedSales.kg": "Amount, kg",
  "feedSales.package": "pack {{kg}}",
  "feedSales.addLine": "Add another food",
  "feedSales.payment": "Payment",
  "feedSales.pay.CASH": "Cash",
  "feedSales.pay.CARD": "Card",
  "feedSales.pay.TRANSFER": "Transfer",
  "feedSales.pay.LATER": "Pay later",
  "feedSales.total": "Total",
  "feedSales.sell": "Sell — {{amount}}",
  "feedSales.saveDebt": "Save (unpaid)",
  "feedSales.created": "Sale saved",
  "feedSales.paidDone": "Paid {{amount}}",
  "feedSales.tabAll": "All sales",
  "feedSales.tabUnpaid": "Unpaid ({{count}})",
  "feedSales.empty": "No sales yet",
  "feedSales.date": "Date",
  "feedSales.statusLabel": "Status",
  "feedSales.status.PAID": "Paid",
  "feedSales.status.PARTLY_PAID": "Partly paid",
  "feedSales.status.WAITING": "Unpaid",
  "feedSales.receive": "Take payment",
  "feedSales.payTitle": "Payment: {{name}}",
  "feedSales.remaining": "Still to pay: {{amount}}",
  "feedSales.amount": "Amount",
  "feedSales.errors.name": "Enter the buyer's name",
  "feedSales.errors.client": "Choose a client",
  "feedSales.errors.items": "Add at least one food and amount",
  "feedSales.errors.fixItems": "Fix the food amounts",
  "feedSales.errors.pay": "Choose how they pay",
  "feedSales.errors.kg": "Amount must be above zero",
  "feedSales.errors.stock": "Only {{kg}} in stock",
  "feedSales.errors.save": "Could not save the sale",
};
